import CapacityAdditionalProvision from './Constructor'

export default CapacityAdditionalProvision
export { CapacityAdditionalProvision }
